import client from '../client';

export const SEND_CONTACT_US_MESSAGE = 'SEND_CONTACT_US_MESSAGE';
export const SEND_CONTACT_US_MESSAGE_SUCCESS = 'SEND_CONTACT_US_MESSAGE_SUCCESS';

export const sendContactUsMessage = values => ({
  type: SEND_CONTACT_US_MESSAGE,
  promise: client.post('contact-us', values),
});
